import styled from "styled-components";

export const SubmitButton = styled.button`
  width: 40%;
  padding: 10px;
  color: #fff;
  border: none;
  outline: none;
  border-radius: 10px;
  cursor: pointer;
  background-color: green;
  font-size: 1.2rem;

  @media (max-width: 768px) {
    width: 60%;
    font-size: 1.1rem;
  }

  @media (max-width: 480px) {
    width: 100%;
    font-size: 1rem;
    padding: 12px;
  }
`;

export const CancelButton = styled.button`
  width: 40%;
  padding: 10px;
  color: #fff;
  border: none;
  outline: none;
  border-radius: 10px;
  cursor: pointer;
  background-color: red;
  font-size: 1.2rem;

  @media (max-width: 768px) {
    width: 60%;
    font-size: 1.1rem;
  }

  @media (max-width: 480px) {
    width: 100%;
    font-size: 1rem;
    padding: 12px;
  }
`;

export const ExitButton = styled.button`
  position: absolute;
  top: 10%;
  right: 5%;
  background: none;
  outline: none;
  border: none;
  cursor: pointer;
  color: red;
  width: 35px;
  height: 35px;
  border-radius: 50%;
  font-weight: 600;
  font-size: 1.5rem;
  background-color: white;

  @media (max-width: 480px) {
    width: 40px;
    height: 40px;
    font-size: 1.4rem;
    top: 8%;
    right: 4%;
  }
`;

export const ClickButton = styled.button`
  background: #142121;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 70%;
  font-size: 18px;
  letter-spacing: 0.7px;
  padding: 10px;
  border-radius: 999px;
  border: none;
  outline: none;
  margin-bottom: 10px;
  margin-top: 4px;
  cursor: pointer;
  text-decoration: none;
  box-shadow: 0 3px 10px rgba(58, 106, 150, 0.35);
  transition: background 0.2s ease, box-shadow 0.2s ease, transform 0.15s ease;

  &:hover {
    background: #bbe1f7d3;
    box-shadow: 0 5px 16px rgba(58, 106, 150, 0.4);
    transform: translateY(-1px);
  }

  @media (max-width: 768px) {
    width: 80%;
    font-size: 1.1rem;
  }

  @media (max-width: 480px) {
    width: 100%;
    height: 48px;
    font-size: 1rem;
    padding: 12px;
  }
`;
